import createIcon from '../../createIcon';

/**
 * @component @name MarkAsUnread
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguODMgNy41SDE2LjIzTDEwLjUgNC41TDQgNy45VjE3LjVDMi45IDE3LjUgMiAxNi42IDIgMTUuNVY3LjY3QzIgNy4xNCAyLjMyIDYuNTggMi44IDYuMzNMMTAuNSAyLjVMMTguMDQgNi4zM0MxOC40NyA2LjU2IDE4Ljc3IDcuMDMgMTguODMgNy41Wk0yMCA4LjVIN0M1LjkgOC41IDUgOS40IDUgMTAuNVYxOS41QzUgMjAuNiA1LjkgMjEuNSA3IDIxLjVIMjBDMjEuMSAyMS41IDIyIDIwLjYgMjIgMTkuNVYxMC41QzIyIDkuNCAyMS4xIDguNSAyMCA4LjVaTTIwIDEyLjE3TDEzLjUgMTUuNUw3IDEyLjE3VjEwLjVMMTMuNSAxMy44M0wyMCAxMC41VjEyLjE3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MarkAsUnread = createIcon('MarkAsUnread', [
  [
    'path',
    {
      d: 'M18.83 7.5H16.23L10.5 4.5L4 7.9V17.5C2.9 17.5 2 16.6 2 15.5V7.67C2 7.14 2.32 6.58 2.8 6.33L10.5 2.5L18.04 6.33C18.47 6.56 18.77 7.03 18.83 7.5ZM20 8.5H7C5.9 8.5 5 9.4 5 10.5V19.5C5 20.6 5.9 21.5 7 21.5H20C21.1 21.5 22 20.6 22 19.5V10.5C22 9.4 21.1 8.5 20 8.5ZM20 12.17L13.5 15.5L7 12.17V10.5L13.5 13.83L20 10.5V12.17Z',
      key: '1dt0w2',
    },
  ],
]);

export default MarkAsUnread;
